module.exports = __webpack_public_path__ + "static/media/16-Essen@3x.04db06ab.jpg";